<template>
    <b-modal id="modal-politica-privacidade" size="xl" hide-header :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <template v-slot:default="{ hide }">
            <embed style="width: 100%; height: 80vh" :src="pdf" />
            <!-- <pdfx v-for=" i in numPages" ref="pdfPoliticaPrivacidade" :page="i" :src="vpdf" style="width:100%" v-bind:key="i"></pdfx> -->
        </template>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="lg" variant="danger" @click="devolveResposta('n')" class="mr-auto">Recusar</b-button>
            <b-button size="lg" variant="success" @click="devolveResposta('s')" >Aceitar</b-button>
        </template>
  </b-modal>
</template>
<script>
import pdfx from "vue-pdf";

export default {
    components: {
        pdfx
    },
    methods: {
        devolveResposta(resposta){
            this.$emit('resposta',{respostaFinal: resposta});
            this.$bvModal.hide('modal-politica-privacidade');
        },
    },
    created() {
        // Define the direct path to your PDF file
        let pdfPath = "../pdf/politica-privacidade_2022-12-19.pdf";
        this.pdf = pdfPath;
        // Create the loading task directly with the file path
        let loadingTask = pdfx.createLoadingTask(pdfPath);

        // Access the promise to get PDF metadata (like numPages)
        loadingTask.promise.then((pdf) => {
            this.numPages = pdf.numPages;
        }).catch((error) => {
            console.error("Error loading the PDF:", error);
        });

        // Assign the loading task to vpdf
        this.vpdf = loadingTask;
    },


    data(){
        return{
            resposta: 's',
            vpdf:null,
            numPages:null,
            pdf:''
        }
    },
}
</script>
<style scoped>

</style>
